export const feedbackOverlay = () => {

    const contactUsButton = document.querySelectorAll(".contact-us")

    if (contactUsButton) {

        const feedbackOverlay = document.querySelector(".feedback-overlay__wrapper")
        const feedbackOverlayCloseButton = document.querySelector(".feedback-overlay__close-button")
        const bodyTag = document.querySelector("body")
        
        contactUsButton.forEach(button => {
            button.addEventListener("click", (e) => { 
                e.preventDefault()    
                feedbackOverlay.classList.add("feedback-overlay__wrapper-active")
                bodyTag.classList.add("invisible-scrollbar")
            })
        })    
    
        feedbackOverlayCloseButton.addEventListener("click", () => {
            feedbackOverlay.classList.remove("feedback-overlay__wrapper-active") 
            bodyTag.classList.remove("invisible-scrollbar")           
        })
    }
    
}